import moment from "moment";

export default function formatDate(time) {
  return time ? moment(time).format("DD/MM/YYYY hh:mma") : "";
}
